import appInfo from '../app-info';
import { call_post_api } from './api_helper';
export async function select_all() {
    return call_post_api(appInfo.api_url + '/dm_coso/select_all');
};